import Api from "@/api"
import { ContentLoading } from "@/components/loading/StateLoading"
import { usePagedFilteredSearching } from "@/composition/usePageFilteredSearching"
import {
	IncidentStatus,
	IncidentsSortBy,
	SortDirection,
	SystemRole,
	type SearchIncidentsRequest,
	type SearchIncidentsResult,
} from "@/models"
import BasicPage from "@/pages/BasicPage"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import AuthorizeRole from "../AuthorizeRole"
import { bindIncidentsFilterToQuery } from "../shared/incident-searching/bindIncidentFilters"
import IncidentsList from "./IncidentsList"

const defaultRequestOptions = (): SearchIncidentsRequest => ({
	page: 1,
	pageSize: 12,
	filter: {
		year: null,
		emergencyPhases: [],
		statuses: [IncidentStatus.Open, IncidentStatus.Closed],
		incidentTypeIds: [],
	},
	sortBy: IncidentsSortBy.IncidentId,
	sortDirection: SortDirection.Descending,
})

const IncidentLogsPage: ReactiveComponent = () => {
	const { requestOptions, loadableRef, getResults } = usePagedFilteredSearching<
		SearchIncidentsResult,
		SearchIncidentsRequest
	>({
		loadValue: async (request) => await Api.incidents.search(request),
		getDefault: defaultRequestOptions,
	})

	bindIncidentsFilterToQuery(requestOptions.filter)

	return () => (
		<AuthorizeRole role={SystemRole.CoastguardReadOnly}>
			<BasicPage title="All Incident Logs" class="flex flex-col">
				<ContentLoading stores={[loadableRef]}>
					<IncidentsList request={requestOptions} result={getResults()} />
				</ContentLoading>
			</BasicPage>
		</AuthorizeRole>
	)
}

export default defineComponent(IncidentLogsPage)
